import React, { useState } from 'react'
import {
    Box, Tabs, Tab, TextField, Button, Grid, Typography, Card
} from '@mui/material'

function LiquidityManagement() {

    const [tab, setTab] = useState(0)

    const handleChange = (event, newValue) => {
        setTab(newValue)
    }

    return (
        <div style={{ padding: '20px' }}>
            <Card style={{ padding: '10px', paddingBottom: '60px' }}>
                <Typography variant="h5" gutterBottom>
                    Liquidity Management
                </Typography>

                {/* Tabs */}
                <Tabs value={tab} onChange={handleChange}>
                    <Tab label="Liquidity - USDT" />
                    <Tab label="Liquidity Deposit - USDT" />
                    <Tab label="Withdrawal - USDT" />
                </Tabs>

                <Box mt={3}>

                    {/* TAB 1: Liquidity */}
                    {tab === 0 && (
                        <Grid container spacing={2}>
                            <Grid item xs={4}>
                                <TextField fullWidth label="Exchange Name" size="small" />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField fullWidth label="Current Balance" size="small" />
                            </Grid>

                            <Grid item xs={12}>
                                <Button variant="contained">Save</Button>
                            </Grid>
                        </Grid>
                    )}

                    {/* TAB 2: Deposit */}
                    {tab === 1 && (
                        <Grid container spacing={2}>
                            <Grid item xs={4}>
                                <TextField fullWidth label="Exchange Name" size="small" />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField fullWidth label="Deposit Amount" size="small" />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    fullWidth
                                    type="date"
                                    label="Deposit Date"
                                    InputLabelProps={{ shrink: true }}
                                    size="small"
                                />
                            </Grid>

                            <Grid item xs={4}>
                                <TextField fullWidth label="Deposited By" size="small" />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField fullWidth label="Transaction Hash" size="small" />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField fullWidth label="Remark" size="small" />
                            </Grid>

                            <Grid item xs={12}>
                                <Button variant="contained">Save</Button>
                            </Grid>
                        </Grid>
                    )}

                    {/* TAB 3: Withdrawal */}
                    {tab === 2 && (
                        <Grid container spacing={2}>
                            <Grid item xs={4}>
                                <TextField fullWidth label="Exchange Name" size="small" />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField fullWidth label="Amount" size="small" />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    fullWidth
                                    type="date"
                                    label="Withdrawal Date"
                                    InputLabelProps={{ shrink: true }}
                                    size="small"
                                />
                            </Grid>

                            <Grid item xs={6}>
                                <TextField fullWidth label="Reason for Withdrawal" size="small" />
                            </Grid>

                            <Grid item xs={12}>
                                <Button variant="contained">Save</Button>
                            </Grid>
                        </Grid>
                    )}

                </Box>
            </Card>
        </div>
    )
}

export default LiquidityManagement